
var Mediator = require('./Mediator.js');

/**
 * 操作jcanvas图层
 */
var Opreations =  {

  //根据圆心与旋转角算出新坐标
  //x1、y1是点坐标，x0、y0是圆心坐标
  rotate: function (x1, y1, x0, y0, angle) {
    //获取点到圆心距离
    var d1 = Math.sqrt(Math.pow(y0 - y1, 2) + Math.pow(x0 - x1, 2));
    //根据角度和点心距离，求未知点到点心线的距离
    var d2 = d1 * Math.sin(angle * 2 * Math.PI / 360);
    var d3 = d1 * Math.cos(angle * 2 * Math.PI / 360);

    //4、求过未知点垂直于点心线的交点
    var dx = x0 - x1;
    var dy = y0 - y1;
    var x2 = x1 + (d1 - d3) / d1 * dx;
    var y2 = y1 + (d1 - d3) / d1 * dy;

    var getQuadrant = function () {
      var quadrant;
      if (x1 === x0 && y1 === y0) {
        quadrant = '0';
      }
      if (y1 === y0) {
        if (x1 < x0) {
          quadrant = '1';
        } else {
          quadrant = '3';
        }
      } else if (x1 === x0) {
        if (y1 < y0) {
          quadrant = '2';
        } else {
          quadrant = '4';
        }
      } else {
        if (x1 < x0 && y1 < y0) {
          quadrant = '5';
        }
        if (x1 > x0 && y1 < y0) {
          quadrant = '6';
        }
        if (x1 > x0 && y1 > y0) {
          quadrant = '7';
        }
        if (x1 < x0 && y1 > y0) {
          quadrant = '8';
        }
      }
      return quadrant;
    }
    //根据象限和旋转角度选择位置
    var choicePoint = function () {
      var quadrant = getQuadrant();
      if (quadrant === '0') {
        return {'x': x1, 'y': y1};
      }
      if (quadrant === '1' || quadrant === '4') {
        return {'x': location.x2, 'y': location.y2};
      }
      if (quadrant === '2' || quadrant === '3') {
        return {'x': location.x1, 'y': location.y1};
      }
      if (quadrant === '5' || quadrant === '6') {
        if (angle > 180) {
          return {'x': location.x1, 'y': location.y1};
        } else {
          return {'x': location.x2, 'y': location.y2};
        }
      }
      if (quadrant === '7' || quadrant === '8') {
        if (angle > 180) {
          return {'x': location.x2, 'y': location.y2};
        } else {
          return {'x': location.x1, 'y': location.y1};
        }
      }
    };

    var location;
    if (y1 === y0) {
      location = {'x1': x2, 'y1': y1 + d2, 'x2': x2, 'y2': y1 - d2};
    } else if (x1 === x0) {
      location = {'x1': x2 + d2, 'y1': y2, 'x2': x2 - d2, 'y2': y2};
    } else {
      var k1 = (y0 - y1) / (x0 - x1);
      var k2 = 0 - 1 / k1;

      location = Opreations.getLocation(k2, x2, y2, d2);
    }
    return choicePoint();
  },
  lineRotate: function (x1, y1, x0, y0, angle, newAngle) {
    //获取点到圆心距离
    var d1 = Math.sqrt(Math.pow(y0 - y1, 2) + Math.pow(x0 - x1, 2));
    //根据角度和点心距离，求未知点到点心线的距离
    var d2 = d1 * Math.sin(angle * 2 * Math.PI / 360);
    var d3 = d1 * Math.cos(angle * 2 * Math.PI / 360);

    //4、求过未知点垂直于点心线的交点
    var dx = x0 - x1;
    var dy = y0 - y1;
    var x2 = x1 + (d1 - d3) / d1 * dx;
    var y2 = y1 + (d1 - d3) / d1 * dy;

    var getQuadrant = function () {
      var quadrant;
      if (x1 === x0 && y1 === y0) {
        quadrant = '0';
        return quadrant;
      }
      if (y1 === y0) {
        if (x1 < x0) {
          quadrant = '1';
        } else {
          quadrant = '3';
        }
      } else if (x1 === x0) {
        if (y1 < y0) {
          quadrant = '2';
        } else {
          quadrant = '4';
        }
      } else {
        if (x1 < x0 && y1 < y0) {
          quadrant = '5';
        }
        if (x1 > x0 && y1 < y0) {
          quadrant = '6';
        }
        if (x1 > x0 && y1 > y0) {
          quadrant = '7';
        }
        if (x1 < x0 && y1 > y0) {
          quadrant = '8';
        }
      }
      return quadrant;
    };
    //根据象限和旋转角度选择位置
    var choicePoint = function () {
      var quadrant = getQuadrant();
      if (quadrant === '0') {
        return {'x': x1, 'y': y1};
      }
      if (quadrant === '1' || quadrant === '4') {
        return {'x': location.x2, 'y': location.y2};
      }
      if (quadrant === '2' || quadrant === '3') {
        return {'x': location.x1, 'y': location.y1};
      }
      if (quadrant === '5' || quadrant === '6') {
        if (angle < 0) {
          return {'x': location.x1, 'y': location.y1};
        } else {
          return {'x': location.x2, 'y': location.y2};
        }
      }
      if (quadrant === '7' || quadrant === '8') {
        if (angle < 0) {
          return {'x': location.x2, 'y': location.y2};
        } else {
          return {'x': location.x1, 'y': location.y1};
        }
      }
    };

    var location;

    if (angle === 0 || angle === 360 || angle === -360) {
      return {'x': x1, 'y': y1};
    }
    if (y1 === y0) {
      location = {'x1': x2, 'y1': y1 + d2, 'x2': x2, 'y2': y1 - d2};
    } else if (x1 === x0) {
      location = {'x1': x2 + d2, 'y1': y2, 'x2': x2 - d2, 'y2': y2};
    } else {
      var k1 = (y0 - y1) / (x0 - x1);
      var k2 = 0 - 1 / k1;
      location = Opreations.getLocation(k2, x2, y2, d2);
    }
    var test = choicePoint();
    return test;
  },
  getAngle: function (centerX, centerY, mx, my) {//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
    var x = Math.abs(centerX - mx);
    var y = Math.abs(centerY - my);
    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var cos = y / z;
    var radina = Math.acos(cos);//用反三角函数求弧度
    var angle = Math.floor(180 / (Math.PI / radina));//将弧度转换成角度

    if (mx > centerX && my > centerY) {//鼠标在第四象限
      angle = 180 - angle;
    }
    if (mx == centerX && my > centerY) {//鼠标在y轴负方向上
      angle = 180;
    }
    if (mx > centerX && my == centerY) {//鼠标在x轴正方向上
      angle = 90;
    }
    if (mx < centerX && my > centerY) {//鼠标在第三象限
      angle = 180 + angle;
    }
    if (mx < centerX && my == centerY) {//鼠标在x轴负方向
      angle = 270;
    }
    if (mx < centerX && my < centerY) {//鼠标在第二象限
      angle = 360 - angle;
    }
    return angle;
  },
  getLocation: function (k, centerX, centerY, d) {
    var b = centerY - centerX * k;
    var A = b - centerY;
    var B = 0 - centerX;
    var o = k * k + 1;
    var p = 2 * A * k + 2 * B;
    var q = A * A + B * B - d * d;

    var x1 = ((0 - p) - Math.sqrt(p * p - 4 * o * q)) / (2 * o);
    var x2 = ((0 - p) + Math.sqrt(p * p - 4 * o * q)) / (2 * o);
    var y1 = k * x1 + b;
    var y2 = k * x2 + b;
    return {'x1': x1, 'y1': y1, 'x2': x2, 'y2': y2};
  },
  getRotatePointLocation: function (x1, x2, y1, y2) {
    //计算用来控制旋转的悬停点位置
    var x, y;
    var midX = (x1 + x2) / 2;
    var midY = (y1 + y2) / 2;
    if (x1 === x2) {
      x = x1 + 30;
      y = midY;
    } else if (y1 === y2) {
      x = midX;
      y = y1 - 30;
    } else {
      var k = 0 - (x2 - x1) / (y2 - y1);
      var location = Opreations.getLocation(k, midX, midY, 30);
      if (y2 < y1) {
        x = location.x1;
        y = location.y1;
      } else {
        x = location.x2;
        y = location.y2;
      }
    }
    return {name: 'pointRotate', x: x, y: y,};
  },

  initRectanglePoint: function (x, y, w, h, templete, angle) {

    var left = {'x': x, 'y': y + h / 2};
    var top = {'x': x + w / 2, 'y': y};
    var right = {'x': x + w, 'y': y + h / 2};
    var bottom = {'x': x + w / 2, 'y': y + h};

    var leftTop = {'x': x, 'y': y};
    var rightTop = {'x': x + w, 'y': y};
    var rightBottom = {'x': x + w, 'y': y + h};
    var leftBottom = {'x': x, 'y': y + h};
    if (angle && angle != 0 && angle != 180) {
      left = Opreations.rotate(left.x, left.y, x + w / 2, y + h / 2, angle);
      top = Opreations.rotate(top.x, top.y, x + w / 2, y + h / 2, angle);
      right = Opreations.rotate(right.x, right.y, x + w / 2, y + h / 2, angle);
      bottom = Opreations.rotate(bottom.x, bottom.y, x + w / 2, y + h / 2, angle);
      leftTop = Opreations.rotate(leftTop.x, leftTop.y, x + w / 2, y + h / 2, angle);
      rightTop = Opreations.rotate(rightTop.x, rightTop.y, x + w / 2, y + h / 2, angle);
      rightBottom = Opreations.rotate(rightBottom.x, rightBottom.y, x + w / 2, y + h / 2, angle);
      leftBottom = Opreations.rotate(leftBottom.x, leftBottom.y, x + w / 2, y + h / 2, angle);
    }
    var pointLeft = $.extend({}, templete, {
      name: 'pointLeft',
      x: left.x, y: left.y,
    });
    var pointTop = $.extend({}, templete, {
      name: 'pointTop',
      x: top.x, y: top.y
    });
    var pointRight = $.extend({}, templete, {
      name: 'pointRight',
      x: right.x, y: right.y
    });
    var pointBottom = $.extend({}, templete, {
      name: 'pointBottom',
      x: bottom.x, y: bottom.y
    });
    var pointLeftTop = $.extend({}, templete, {
      name: 'pointLeftTop',
      x: leftTop.x, y: leftTop.y
    });
    var pointRightTop = $.extend({}, templete, {
      name: 'pointRightTop',
      x: rightTop.x, y: rightTop.y
    });
    var pointRightBottom = $.extend({}, templete, {
      name: 'pointRightBottom',
      x: rightBottom.x, y: rightBottom.y
    });
    var pointLeftBottom = $.extend({}, templete, {
      name: 'pointLeftBottom',
      x: leftBottom.x, y: leftBottom.y
    });
    //var rotatePoint = Opreations.getRotatePointLocation(leftTop.x, rightTop.x, leftTop.y, rightTop.y);
    //var pointRotate = $.extend({}, templete, rotatePoint);
    return [pointLeft, pointTop, pointRight, pointBottom, pointLeftTop,
      pointRightTop, pointRightBottom, pointLeftBottom];
  },
  initShapePoint: function (templete, layer) {
    var x = layer.x;
    var y = layer.y;
    var w = layer.width;
    var h = layer.height;
    return Opreations.initRectanglePoint(x, y, w, h, templete, layer.rotate);
  },
  initPencilPoint: function (templete, layer) {
    var angle = layer.data.angle;
    var box = Opreations.figureLineBox(layer);
    return Opreations.initRectanglePoint(box.x, box.y, box.w, box.h, templete, angle);
  },
  initArrowPoint: function (templete, layer) {
    var x1 = layer.x1;
    var x2 = layer.x2;
    var y1 = layer.y1;
    var y2 = layer.y2;
    var w = layer.strokeWidth;

    //centerX = (x1 + x2)/2;
    //centerY = (y1 + y2)/2;

    var d = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    var a = (w + d) / d;
    var offX = (x2 - x1) * a + x1;
    var offY = (y2 - y1) * a + y1;

    var rotatePoint = Opreations.getRotatePointLocation(x1, x2, y1, y2);

    var pointBegin = $.extend({}, templete, {
      name: 'pointBegin',
      x: layer.x1,
      y: layer.y1,
    });
    var pointEnd = $.extend({}, templete, {
      name: 'pointEnd',
      x: offX,
      y: offY,
    });
    //var pointRotate = $.extend({}, templete, rotatePoint);

    return [pointBegin, pointEnd];
  },
  initTextPoint: function (templete, layer) {
    var target = Mediator.getBindLayers(layer)[0];
    var x = target.x;
    var y = target.y;
    var w = target.width;
    var h = target.height;
    return Opreations.initRectanglePoint(x, y, w, h, templete, target.rotate);
  },

  moveShapeLayer: function (target, dx, dy) {
    if(target != null && (dx !== 0 || dy !== 0)) {
      target.x += dx;
      target.y += dy;
      target.data.isChanged = true;
      return true;
    }
  },
  moveLineLayer: function (target, dx, dy) {
    if (target != null && (dx !== 0 || dy !== 0)) {
      var box = Opreations.figureLineBox(target);
      var i = 1;
      while (true) {
        var x = target['x' + i];
        var y = target['y' + i];
        if (x === undefined || y === undefined) {
          break;
        }
        target['x' + i] += dx;
        target['y' + i] += dy;
        i++;
      }
      target.data.isChanged = true;
      return true;
    }
    return false;
  },
  moveTextLayer: function (target, dx, dy) {
    if (target != null && (dx !== 0 || dy !== 0)) {
      var layers = Mediator.getBindLayers(target);
      for (var i = 0; i < layers.length; i++) {
        layers[i].x += dx;
        layers[i].y += dy;
        layers[i].data.isChanged = true;
      }
      return true;
    }
    return false;
  },

  filledTools: ['FilledRectTool', 'FilledEllipseTool', 'TextTool'],
  dragShapeBorder: function (target, checkedPoint, dx, dy, mx, my) {
    var result = false;
    var minValue = target.strokeWidth;       //线框工具最小值为线宽，实心工具最小值为5
    if(target && Opreations.filledTools.indexOf(target.data.tool) !== -1) {
      minValue = 5;
    }
    var left = function () {
      if(dx === 0 || Math.abs(target.width-dx) < minValue) {
        return;
      }

      target.width -= dx;
      target.x += dx;
      target.data.isChanged = true;
      result = true;
    };
    var top = function () {
      if(dy === 0 || Math.abs(target.height-dy) < minValue) {
        return;
      }
      target.height -= dy;
      target.y += dy;
      target.data.isChanged = true;
      result = true;
    };
    var right = function () {
      if(dx === 0 || Math.abs(target.width+dx) < minValue) {
        return;
      }
      target.width += dx;
      target.data.isChanged = true;
      result = true;
    };
    var bottom = function () {
      if(dy === 0 || Math.abs(target.height+dy) < minValue) {
        return;
      }
      target.height += dy;
      target.data.isChanged = true;
      result = true;
    };

    if (checkedPoint.name === 'pointLeft') {
      left();
    }
    if (checkedPoint.name === 'pointTop') {
      top();
    }
    if (checkedPoint.name === 'pointRight') {
      right();
    }
    if (checkedPoint.name === 'pointBottom') {
      bottom();
    }
    if (checkedPoint.name === 'pointLeftTop') {
      left();
      top();
    }
    if (checkedPoint.name === 'pointRightTop') {
      right();
      top();
    }
    if (checkedPoint.name === 'pointRightBottom') {
      right();
      bottom();
    }
    if (checkedPoint.name === 'pointLeftBottom') {
      left();
      bottom();
    }
    if (checkedPoint.name === 'pointRotate') {
      var centerX = target.x + target.width / 2;
      var centerY = target.y + target.height / 2;
      var angle = Opreations.getAngle(centerX, centerY, mx, my);
      target.rotate = angle;
    }

    return result;
  },
  dragPencilBorder: function (target, checkedPoint, dx, dy, mx, my) {
    var box = Opreations.figureLineBox(target);
    var toLeftRatio = (box.w - dx) / box.w;
    var toTopRatio = (box.h - dy) / box.h;
    var toRightRatio = (box.w + dx) / box.w;
    var toBottomRatio = (box.h + dy) / box.h;
    var i = 1;
    var result = false;
    var minValue = 10;
    var left = function (x, y) {
      if(dx === 0 || Math.abs(box.w * toLeftRatio) <= minValue || !isFinite(toLeftRatio)) {
        return;
      }
      target['x' + i] = (x - box.x) * toLeftRatio + box.x + dx;
      target.data.isChanged = true;
      result = true;
      if(toLeftRatio < 0) {
        Mediator.flipPoints(checkedPoint, 'LR');
      }
    };
    var top = function (x, y) {
      if(dy === 0 || Math.abs(box.h * toTopRatio) <= minValue || !isFinite(toTopRatio)) {
        return;
      }
      target['y' + i] = (y - box.y) * toTopRatio + box.y + dy;
      target.data.isChanged = true;
      result = true;
      if(toTopRatio < 0) {
        Mediator.flipPoints(checkedPoint, 'TB');
      }
    };
    var right = function (x, y) {
      if(dx === 0 || Math.abs(box.w * toRightRatio) <= minValue || !isFinite(toRightRatio)) {
        return;
      }
      target['x' + i] = (x - box.x) * toRightRatio + box.x;
      target.data.isChanged = true;
      result = true;
      if(toRightRatio < 0) {
        Mediator.flipPoints(checkedPoint, 'LR');
      }
    };
    var bottom = function (x, y) {
      if(dy === 0 || Math.abs(box.h * toBottomRatio) <= minValue || !isFinite(toBottomRatio)) {
        return;
      }
      target['y' + i] = (y - box.y) * toBottomRatio + box.y;
      target.data.isChanged = true;
      result = true;
      if(toBottomRatio < 0) {
        Mediator.flipPoints(checkedPoint, 'TB');
      }
    };

    /*var x0 = box.x + box.w / 2;
     var y0 = box.y + box.h / 2;

     var a = Opreations.getAngle(x0, y0, rpX, rpY);
     if(!target.data.oldAngle) {
     target.data.oldAngle = a;
     }
     var newAngle = Opreations.getAngle(x0, y0, mx, my);
     var angle = newAngle - target.data.oldAngle;
     target.data.oldAngle = newAngle;
     target.data.angle = newAngle - a;*/

    while (true) {
      var x = target['x' + i];
      var y = target['y' + i];
      if (x === undefined || y === undefined) {
        break;
      }
      if (checkedPoint.name === 'pointLeft') {
        left(x, y);
      }
      if (checkedPoint.name === 'pointTop') {
        top(x, y);
      }
      if (checkedPoint.name === 'pointRight') {
        right(x, y);
      }
      if (checkedPoint.name === 'pointBottom') {
        bottom(x, y);
      }
      if (checkedPoint.name === 'pointLeftTop') {
        left(x, y);
        top(x, y);
      }
      if (checkedPoint.name === 'pointRightTop') {
        right(x, y);
        top(x, y);
      }
      if (checkedPoint.name === 'pointRightBottom') {
        right(x, y);
        bottom(x, y);
      }
      if (checkedPoint.name === 'pointLeftBottom') {
        left(x, y);
        bottom(x, y);
      }
      if (checkedPoint.name === 'pointRotate') {
        /*var location = Opreations.lineRotate(x, y, x0, y0, angle, newAngle);
         target['x' + i] = location.x;
         target['y' + i] = location.y;*/
      }
      i++;
    }
    return result;
  },
  dragArrowBorder: function (target, checkedPoint, dx, dy, mx, my) {
    var result = false;
    if(dx === 0 && dy === 0) {
      return false;
    }
    if (checkedPoint.name === 'pointBegin') {
      //箭头工具最小值为10，不支持过小箭头
      if(Math.sqrt(Math.pow(target.x2-target.x1-dx, 2)+Math.pow(target.y2-target.y1-dy, 2)) < 10){
        return;
      }
      target.x1 += dx;
      target.y1 += dy;
      target.data.isChanged = true;
      result = true;
    }
    if (checkedPoint.name === 'pointEnd') {
      if(Math.sqrt(Math.pow(target.x2-target.x1+dx, 2)+Math.pow(target.y2-target.y1+dy, 2)) < 10){
        return;
      }
      target.x2 += dx;
      target.y2 += dy;
      target.data.isChanged = true;
      result = true;
    }
    if (checkedPoint.name === 'pointRotate') {
      var centerX = (target.x1 + target.x2) / 2;
      var centerY = (target.y1 + target.y2) / 2;
      if (!target.data.oldAngle) {
        target.data.oldAngle = Opreations.getAngle(centerX, centerY, rpX, rpY);
      }
      var newAngle = Opreations.getAngle(centerX, centerY, mx, my);
      var angle = newAngle - target.data.oldAngle;
      target.data.oldAngle = newAngle;
      target.data.angle = angle;
      var location = Opreations.lineRotate(target.x1, target.y1, centerX, centerY, angle, newAngle);
      target['x1'] = location.x;
      target['y1'] = location.y;

      var location = Opreations.lineRotate(target.x2, target.y2, centerX, centerY, angle, newAngle);
      target['x2'] = location.x;
      target['y2'] = location.y;

      /*var centerX = (target.x1 + target.x2) / 2;
       var centerY = (target.y1 + target.y2) / 2;
       var d = Math.sqrt(Math.pow(target.x2 - target.x1, 2) + Math.pow(target.y2 - target.y1, 2)) / 2;
       var angle = Opreations.getAngle(centerX, centerY, mx, my);
       var k = Math.tan(angle * 2 * Math.PI / 360);

       var location = Opreations.getLocation(k, centerX, centerY, d);


       if (90 < angle && angle < 270) {
       target.x1 = location.x2;
       target.y1 = location.y2;
       target.x2 = location.x1;
       target.y2 = location.y1;
       } else {
       target.x1 = location.x1;
       target.y1 = location.y1;
       target.x2 = location.x2;
       target.y2 = location.y2;
       }*/

    }
    Opreations.setArrowSize(target);

    return result;
  },
  dragTextBorder: function (target, checkedPoint, dx, dy, mx, my) {
    var relativeLayers = Mediator.getBindLayers(target);
    var wrapLayer = relativeLayers[0];
    var contentLayer = relativeLayers[1];
    var result = false;
    if (wrapLayer) {
      result = Opreations.dragShapeBorder(wrapLayer, checkedPoint, dx, dy, mx, my);
      if (contentLayer && result) {
        contentLayer.x = Math.min(wrapLayer.x, wrapLayer.x+wrapLayer.width) + 10;
        contentLayer.y = Math.min(wrapLayer.y, wrapLayer.y+wrapLayer.height) + 10;
        contentLayer.text = Mediator.figureTextWidth(contentLayer.data.text, contentLayer._args, wrapLayer);
        contentLayer.data.isChanged = true;
      }
    }
    return result;
  },

  figureLineBox: function (layer) {
    var i = 1;
    var minX = Number.MAX_VALUE;
    var minY = Number.MAX_VALUE;
    var maxX = 0, maxY = 0;
    while (true) {
      var x = layer['x' + i];
      var y = layer['y' + i];
      if (x === undefined || y === undefined) {
        break;
      }
      if (x < minX) {
        minX = x;
      }
      if (x > maxX) {
        maxX = x;
      }
      if (y < minY) {
        minY = y;
      }
      if (y > maxY) {
        maxY = y;
      }
      i++;
    }
    return {x: minX, y: minY, w: maxX - minX, h: maxY - minY};
  },
  setArrowSize: function(target) {
    var arrowLen = Math.sqrt(Math.pow(target.x2-target.x1, 2) + Math.pow(target.y2-target.y1, 2));
    if(arrowLen < 80) {
      target.arrowRadius = 7;
      target.arrowAngle = 80;
    } else if(arrowLen < 200) {
      target.arrowRadius = 10;
      target.arrowAngle = 60;
    } else {
      target.arrowRadius = 15;
      target.arrowAngle = 40;
    }
  }
};

module.exports = Opreations;


// WEBPACK FOOTER //
// ./src/helper/Review/PaintOpreations.js